import type { BuildMapLinkParams, LocationDescriptor } from './interfaces';

function toMapsTextValue(loc: LocationDescriptor): string {
  switch (loc.type) {
    case 'address':
      return loc.address;

    case 'coords':
      return `${loc.latitude},${loc.longitude}`;

    case 'place':
      return loc.placeId;

    default:
      throw new Error(`Unsupported location type: ${(loc as any).type}`);
  }
}

export const buildGoogleMapDirectionsLink = ({ origin, destination, waypoints }: BuildMapLinkParams) => {
  const params = new URLSearchParams({
    api: '1',
    origin: toMapsTextValue(origin),
    destination: toMapsTextValue(destination),
  });

  params.set('travelmode', 'driving');
  if (origin.type === 'place') {
    params.set('origin_place_id', origin.placeId);
  }

  if (destination.type === 'place') {
    params.set('destination_place_id', destination.placeId);
  }

  if (waypoints?.length) {
    params.set('waypoints', waypoints.map(toMapsTextValue).join('|'));

    const placeWaypoints = waypoints.filter(
      (w): w is Extract<LocationDescriptor, { type: 'place' }> => w.type === 'place'
    );

    if (placeWaypoints.length === waypoints.length) {
      params.set('waypoint_place_ids', placeWaypoints.map((w) => w.placeId).join('|'));
    }
  }

  return `https://www.google.com/maps/dir/?${params.toString()}`;
};

namespace BuildGoogleMapsAddressLink {
  export type Params = {
    address: string;
  };
}

export function buildGoogleMapsAddressLink({ address }: BuildGoogleMapsAddressLink.Params) {
  const encoded = encodeURIComponent(address).replaceAll('%20', '+');
  return `https://www.google.com/maps/search/?api=1&query=${encoded}`;
}
